<template>
  <MobileHeader 
    v-if="(isMovil||isLandscape)" 
  />
  <TheHeader 
    v-if="(!isMovil||!isLandscape)"
    :is-home="isHome"
  />
  <!-- <div 
    v-if="!isMovil&&!isEncuentro&&!isArticulo&&!isProyecto"    
    class="bg-gray-40 w-full h-16" 
  >
  </div> -->
  <MovilMenu 
    v-if="menuVisibility&&isMovil"
  />
  <the-main>
    <router-view></router-view>
  </the-main>
  <!-- <TheFooter v-if="!isEncuentro&&!isArticulo&&!isProyecto&&!isNovedad&&!isRecreacion" />
  <EncuentroFooter v-if="isEncuentro" /> -->
  <TheFooter v-if="!isEncuentro&&!isArticulo&&!isProyecto&&!isNovedad&&!isRecreacion" />
  <EncuentroFooter v-if="isEncuentro" />
</template> 


<script>
import visibilityHandle from '@/mixins/visibilityHandle.js';
import isPage from '@/mixins/isPageMixin.js';
import goSectionMixin from '@/mixins/goSectionMixin.js';

import MobileHeader from './components/layout/MobileHeader'
import TheHeader from './components/layout/TheHeader.vue'
import MovilMenu from './components/layout/MovilMenu.vue'
import TheMain from './components/layout/TheMain.vue'
import TheFooter from './components/layout/TheFooter.vue'
import EncuentroFooter from './components/layout/EncuentroFooter.vue'

export default {
  name: 'App',
  components: {
    MovilMenu,
    MobileHeader,
    TheMain,
    TheHeader,
    TheFooter,
    EncuentroFooter
  },
  mixins: [visibilityHandle, isPage, goSectionMixin],
  data () {
    return {
    }
  },
  computed: {
    menuVisibility() {
      return this.$store.getters.getVisibilityMenu
    },
  },
  created() {
    //console.log(this.$applocation);
    this.updateMenu();
    //console.log('updateMenu');
    this.loadCategoriasLudiculas();
  },
  mounted(){

  },
  methods: {
    updateMenu(){
      //console.log('Start Update Menu')
      this.$store.dispatch('wordpress/loadPosts','proyectos').then(()=>{
        //console.log('llamo a la accion Update Menu');
        this.$store.dispatch('updateMenu','proyectos');
      }) 
      
    },
    loadProyectos() {
      //console.log('Load proyectos')
      this.$store.dispatch('wordpress/loadPosts','proyectos');  
    },
    loadCategoriasLudiculas() {
      //console.log('Load proyectos')
      this.$store.dispatch('wordpress/loadCategorias');  
      this.$store.dispatch('wordpress/loadTags'); 
      this.$store.dispatch('wordpress/loadOtrosNombres'); 
    },
  },
  }

</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app strong {
  font-weight: 600;
}

#app {
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;
  align-items: center;
  mix-blend-mode: normal;
  flex-grow: 1;
}

#app.inicio {
  background: url(./assets/textura-carton-yeso-sepia.jpg);
}

#app.somos {
  background: url(./assets/TEXTURA-Nosotxs.webp);
}


.top-7 {
    top: 1.75rem;
}

/* Start: Video Responsive */
.responsive-video-wrap {
    overflow:hidden;
    padding-bottom:400px; 
    /* Adecua este valor para controlar la altura del video */
    position:relative;
    height:0;
}
.responsive-video-wrap iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
}
/* End: Video Responsive */

.has-text-align-center{
  text-align: center;
}
.has-text-align-right{
  text-align: right;
}
.has-text-align-left{
  text-align: left;
}
.is-content-justification-center {
  display: flex;
}

.aspect-video {
    aspect-ratio: 16/9;
}

.aspect-instagram-video{
  aspect-ratio: 9/16;
}

.aspect-square {
  aspect-ratio: 1/1;
}

.pc-mode .encuentroGroup:hover .submenuEncuentros {
    /* background-color: rgb(218, 162, 23); */
    background-color: white;
}

.movil.encuentroGroup:hover .submenuEncuentros {
    background-color: transparent;
}

.movil #submenu-Encuentros {
  width: auto;
}

</style>
